import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DictionaryService } from 'src/app/librarys/serves/public/dictionary.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';
import { KmsEnum } from '../../../serves/kms-enum';
declare var $;
@Component({
  selector: 'app-resource-verify',
  templateUrl: './resource-verify.component.html',
  styleUrls: ['./resource-verify.component.css']
})
export class ResourceVerifyComponent implements OnInit {
  // 接收父组件的数据：操作类型：edit view verify
  @Input() addOrUpdate = '';
  @Input() imgId = '';
  // 向父组件传值
  @Output() verifyNext = new EventEmitter();
  // 当前正在操作的模块：record ：质检记录；verify:实体质检；
  selected:string = ''
  // 质检记录数据
  verifyRecords:any = []
  // 质检备注信息
  remark = '';
  // 当前新增的问题记录
  records:any = [];
  // 问题类型选项
  types:any = [];
  modules:any = [
    {
      id:'1',
      text:'标记信息'
    },
    {
      id:'2',
      text:'关联资源'
    }
  ]
  // 添加问题记录信息
  formModel:any = {}
  // 是否展示添加问题记录模块
  showAddQuestion = false;
  constructor(
    private jwt: SwJwtService,
    private kmsService: KmsService,
    private dicService: DictionaryService,
    private message: SwMassageBoxService,
  ) { }

  ngOnInit() {
    this.types = this.dicService.getDictionaryValueOrName(KmsEnum.KGS_QUESTION_TYPE);
  }
  
  // 滚动条滚动更改头部显示位置
  listenScroll(event) {
    if (event.srcElement.scrollTop > 50) {
        $('.quickMenuHead').addClass('content-fixed');
    } else {
        $('.quickMenuHead').removeClass('content-fixed');
    }
  }

  ngOnChanges(){
    // 判断当前是否为实体质检页面
    if(this.addOrUpdate == 'verify'){
      this.selected = 'verify';
      setTimeout(()=>{
        $('.leftPart').css('left','0');
      },0);
    }

    // 根据实体id查询实体质检记录
    this.kmsService.queryLatestApprovedRecord(this.imgId).subscribe(
      res => {
        if(res.code == '200'){
          let data = res.data;
          this.verifyRecords = [];
          // 过滤出起始状态为待质检的操作记录
          data.forEach(el => {
            if(el.startStatus == 3 && (el.endStatus == 1 || el.endStatus == 4)){
              this.verifyRecords.push(el);
            }
          })
        }
      }
    )
  }

  // 添加问题记录
  addQuestion(){
    let str = this.jwt.getToken('markVerifyConfig');
    if(str){
      this.showAddQuestion =  true;
      this.formModel = JSON.parse(str);
      this.jwt.setToKen('markVerifyConfig','');
    }else{
      this.message.info('请先点击选择一个图像标记！');
    }
  }

  // 编辑问题记录
  editRecord(i){
    this.formModel = JSON.parse(JSON.stringify(this.records[i]));
    this.showAddQuestion = true;
  }

  // 删除问题记录
  deleteRecord(i){
    this.records.splice(i,1);
  }
  
  // 保存、更新问题记录
  onSubmit({ value, valid }, event: Event) {
    if (valid) {
      let isAdd = true;
      for(let i=0;i<this.records.length;i++){
        if(this.records[i].uuid == this.formModel.uuid){
          this.records[i] = JSON.parse(JSON.stringify(this.formModel));
          isAdd = false;
          break;
        }
      }
      if(isAdd){
        this.records.unshift(this.formModel);
      }
      this.showAddQuestion = false;
    }
  }

  // 切换查看质检记录 和 实体质检模块
  select(state){
    this.selected = state;
    $('.leftPart').css('left','0');
  }

  // 关闭当前模块
  hide(){
    $('.leftPart').css('left','-500px');
    this.selected = '';
  }

  // 通过、驳回；并质检下一条
  passOrReject(state){
    let list = JSON.parse(JSON.stringify(this.records));
    list.forEach(el => {
      delete el.uuid;
      let item = this.modules.filter(e => e.id == el.contentModule);
      if(item.length>0){
        el['contentModule'] = item[0].text;
      }else{
        el['contentModule'] = '';
      }
    })
    let params = {
      "approvedRecords": list,
      "foreignId": this.imgId,
      "remark": $.trim(this.remark),
      "status": state
    }
    this.kmsService.queryNextMaterial(params).subscribe(
      res => {
        if(res.code == '200'){
          this.verifyRecords = [];
          this.remark = '';
          this.records = [];
          this.formModel = {};
          this.showAddQuestion = false;
          this.verifyNext.emit(res.data);
        }
      }
    )
  }

  // 根据问题类型code获取名称
  getType(code){
    let items = this.types.filter(el => el.id == code);
    return items.length>0 ? items[0].text : '';
  }
}

